//
// quill_no_img.js
// Theme module
//

'use strict';

(function() {

  //
  // Variables
  //

  var toggle = document.querySelectorAll('[data-toggle="quill_no_img"]');


  //
  // Functions
  //

  function init(el) {
    var elementOptions = el.dataset.options;
        elementOptions = elementOptions ? JSON.parse(elementOptions) : {};
    var defaultOptions = {
      modules: {   
        toolbar: [
        [{ 'size': ['small', false, 'large', 'huge']}],
        ['bold', 'italic', 'underline'],
        [
          {'color': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"]},
          {'background': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"]}
        ], 
        ['link'], 
        [{ 'list': 'ordered'}, { 'list': 'bullet' }], 
        [{ 'script': 'sub'}, { 'script': 'super' }], 
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'align': []}],
        ['clean']
        ]
      },
      theme: 'snow'
    };
    var options = Object.assign(elementOptions, defaultOptions);

    new Quill(el, options);
  }


  //
  // Events
  //

  if (typeof Quill !== 'undefined' && toggle) {
    [].forEach.call(toggle, function(el) {
      init(el);
    });
  }
  
})();